import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

@Component({
  template: `<p *ngIf="!disableErrors" class="help is-danger" [class.hide]="_hide">{{_text | translate : translateOptions }}</p>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./control-error.component.css']
})
export class ControlErrorComponent implements OnInit {
  _text;
  _hide = true;

  public translateOptions;

  @Input() set text(value) {
    if (value !== this._text) {
      if(value && value.indexOf('@') !== -1){
        const valueSplit = value.split('@');
        this.translateOptions = { requiredLength : valueSplit[1]};
        //this.translateOptions = { "requiredLength" : "1", "actualLength" :"2"}
        value = valueSplit[0];
      }
      this._text = value;
      this._hide = !value;
      this.cdr.detectChanges();
    }
  };

  @Input() disableErrors = false;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit() {
  }

}